export default function getAxiosParams(itemParams: any) {
  const params = new URLSearchParams();
  Object.keys(itemParams).forEach(
    (key) => itemParams[key] && params.append(key, itemParams[key])
  );
  return params;
}
